import type { FC } from 'react';
import React from 'react';

import { cnListItem } from './ListItem.cn';
import type { IListItemProps } from './ListItem.types';

import './ListItem.css';

export const ListItem: FC<IListItemProps> = (props) => {
    const {
        className,
        embed,
        fitContent,
        disabled,
        border,
        padding,
        leading,
        trailing,
        children,
        onClick,
    } = props;

    const handleKeypress = React.useCallback(
        (event: React.KeyboardEvent<HTMLDivElement>) => {
            //it triggers by pressing the enter key
            if (event.code === 'Enter' && onClick) {
                onClick();
            }
        },
        [onClick],
    );

    return (
        <div
            className={cnListItem(
                {
                    clickable: onClick !== undefined,
                    embed,
                    fitContent,
                    disabled,
                    border,
                    padding,
                },
                [className],
            )}
            onKeyDown={handleKeypress}
            onClick={onClick}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : 0}
        >
            {leading && <div className={cnListItem('Leading')}>{leading}</div>}
            <div className={cnListItem('Content')}>{children}</div>
            {trailing && <div className={cnListItem('Trailing')}>{trailing}</div>}
        </div>
    );
};
